import { soundsLocation } from '../../consts';

export class Sound {
  readonly name: string;
  readonly volume: number;
  readonly pitch: number;
  readonly weight: number;
  readonly supported: boolean;

  readonly soundLocation: string;

  constructor(value: any) {
    if (typeof value === 'string') {
      this.name = value;
      this.volume = 1;
      this.pitch = 1;
      this.weight = 1;
      this.supported = true;
    } else {
      this.name = value.name;
      this.volume = value.volume || 1;
      this.pitch = value.pitch || 1;
      this.weight = value.weight || 1;
      this.supported = (value.type || 'sound') !== 'event';
    }

    this.soundLocation = `${soundsLocation}/${this.name.replaceAll('.', '/')}.ogg`;
  }
}
